<template>
  <el-dialog
    :visible.sync="visible"
    width="1120px"
    top="6vh"
    append-to-body
    :close-on-click-modal="false"
    :before-close="handleClose"
    custom-class="receipt-account-list-dialog"
  >
    <template slot="title">
      <div class="dialog-title">收款账户管理</div>
    </template>

    <div class="search-bar">
      <div class="search-item">
        <span class="search-label">账号</span>
        <el-input
          v-model="searchForm.bankCardNo"
          clearable
          placeholder="请输入账号"
          @keyup.enter.native="handleSearch"
        ></el-input>
      </div>
      <div class="search-item">
        <span class="search-label">姓名</span>
        <el-input
          v-model="searchForm.payeeName"
          clearable
          placeholder="请输入账号认证姓名"
          @keyup.enter.native="handleSearch"
        ></el-input>
      </div>
      <div class="search-actions">
        <el-button type="primary" @click="handleSearch">筛选</el-button>
        <el-button @click="handleReset">重置</el-button>
      </div>
      <div class="search-extra">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      </div>
    </div>

    <el-table
      border
      stripe
      :data="tableData"
      v-loading="isLoading"
      style="width: 100%"
    >
      <el-table-column label="账户类型" min-width="100">
        <template slot-scope="{ row }">
          {{ getAccountTypeLabel(row) }}
        </template>
      </el-table-column>
      <el-table-column prop="bankCardNo" label="账号&银行卡号" min-width="180" show-overflow-tooltip></el-table-column>
      <el-table-column prop="payeeName" label="姓名" min-width="100" show-overflow-tooltip></el-table-column>
      <el-table-column prop="bankName" label="开户行" min-width="120" show-overflow-tooltip>
        <template slot-scope="{ row }">
          {{ isAlipayAccount(row) ? '--' : (row.bankName || '--') }}
        </template>
      </el-table-column>
      <el-table-column prop="idCardNo" label="身份证号" min-width="160" show-overflow-tooltip>
        <template slot-scope="{ row }">
          {{ displayField(row.idCardNo) }}
        </template>
      </el-table-column>
      <el-table-column prop="mobilePhone" label="手机号" min-width="130" show-overflow-tooltip>
        <template slot-scope="{ row }">
          {{ displayField(row.mobilePhone) }}
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag
            :type="row.status === 1 ? 'success' : 'info'"
            size="small"
            effect="light"
          >
            {{ getStatusLabel(row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="140" fixed="right">
        <template slot-scope="{ row }">
          <template v-if="row.status === 1">
            <el-button type="text" @click="handleDisable(row)">禁用</el-button>
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
          </template>
          <template v-else-if="!isAlipayAccount(row)">
            <el-button type="text" @click="handleEnable(row)">启用</el-button>
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <div class="table-pagination" v-if="pageInfo.total > 0">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="pageInfo.total"
        :page-size="pageInfo.pageSize"
        :current-page.sync="pageInfo.page"
        @current-change="getList"
      ></el-pagination>
    </div>

    <ReceiptAccountFormDialog
      v-if="showFormDialog"
      v-model="showFormDialog"
      :account-id="editAccountId"
      @close="showFormDialog = false; editAccountId = null"
      @on-success="handleFormSuccess"
    />
  </el-dialog>
</template>

<script>
import ReceiptAccountFormDialog from './receipt-account-form-dialog.vue'

const RECEIPT_BANK_NAME_ALIPAY = '支付宝'

export default {
  name: 'ReceiptAccountListDialog',
  components: { ReceiptAccountFormDialog },
  props: {
    value: { type: Boolean, default: false }
  },
  data() {
    return {
      isLoading: false,
      tableData: [],
      searchForm: {
        bankCardNo: '',
        payeeName: ''
      },
      pageInfo: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      showFormDialog: false,
      editAccountId: null
    }
  },
  computed: {
    visible: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.handleReset()
      }
    }
  },
  methods: {
    isAlipayAccount(row) {
      return row.bankName === RECEIPT_BANK_NAME_ALIPAY
    },
    getAccountTypeLabel(row) {
      return this.isAlipayAccount(row) ? '支付宝' : '银行卡'
    },
    getStatusLabel(status) {
      return status === 1 ? '启用' : '禁用'
    },
    displayField(value) {
      if (!value || value === '-') return '--'
      return value
    },
    handleClose() {
      this.$emit('input', false)
      this.$emit('close')
    },
    handleSearch() {
      this.pageInfo.page = 1
      this.getList()
    },
    handleReset(refresh = true) {
      this.searchForm = {
        bankCardNo: '',
        payeeName: ''
      }
      this.pageInfo.page = 1
      if (refresh) {
        this.getList()
      }
    },
    getList() {
      this.isLoading = true
      const params = {
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize
      }
      if (this.searchForm.bankCardNo) {
        params.bankCardNo = this.searchForm.bankCardNo
      }
      if (this.searchForm.payeeName) {
        params.payeeName = this.searchForm.payeeName
      }
      this.$http('get', 'mall/bdM2sSettlementChannelReceipt/list', params).then(res => {
        this.tableData = (res && res.data) || []
        this.pageInfo.total = (res && res.total) || 0
      }).catch(() => {
        this.tableData = []
        this.pageInfo.total = 0
      }).finally(() => {
        this.isLoading = false
      })
    },
    handleAdd() {
      this.showFormDialog = false
      this.editAccountId = null
      this.$nextTick(() => {
        this.showFormDialog = true
      })
    },
    handleEdit(row) {
      if (this.isAlipayAccount(row)) {
        this.$message.warning('支付宝账户暂不支持编辑')
        return
      }
      this.showFormDialog = false
      this.editAccountId = row.id
      this.$nextTick(() => {
        this.showFormDialog = true
      })
    },
    updateStatus(row, status) {
      const actionText = status === 1 ? '启用' : '禁用'
      this.$confirm(`确认${actionText}该收款账户吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http('post', `mall/bdM2sSettlementChannelReceipt/updateStatus?id=${row.id}&status=${status}`).then(() => {
          this.$message.success(`${actionText}成功`)
          this.getList()
          this.$emit('on-success')
        })
      }).catch(() => {})
    },
    handleDisable(row) {
      this.updateStatus(row, 0)
    },
    handleEnable(row) {
      this.updateStatus(row, 1)
    },
    handleFormSuccess() {
      this.getList()
      this.$emit('on-success')
    }
  }
}
</script>

<style scoped>
.dialog-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}
.search-item {
  display: flex;
  align-items: center;
}
.search-label {
  flex-shrink: 0;
  margin-right: 8px;
  color: #666;
  font-size: 14px;
}
.search-item .el-input {
  width: 260px;
}
.search-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.search-extra {
  margin-left: auto;
}
.table-pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
